import React, {useState, useContext, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import { useForm } from 'react-hook-form';  
import { useDispatch } from 'react-redux'; 
import {LoginService} from '../services/LoginService';
import AppContext from '../../shared/components/AppContext';
import {onChangeLanguage, onChangeLoading} from "../../redux/actions/ActionApp";
import { ErrorParse } from '../handlers/ErrorParse';
import { useTranslation } from 'react-i18next';

// Register component
// Shows all register options
// Submit user info and handles the responses
// Used for Client and Respondent register actions
export default function Register() {  

    const location = useLocation();
    const myContext = useContext(AppContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const loginService = LoginService();


    const [typeRole, setTypeRole] = useState('Respondent');
    const [email] = useState(location.state?._profile.email);

    const { register, handleSubmit, getValues, setValue , formState: { errors }, } = useForm();
    const { register: register2, handleSubmit : handleSubmit2, getValues: getValues2, setValue:setValue2, setError: setError2 , formState: { errors: errors2 } } = useForm();

    useEffect(() => {
        if (Boolean((typeRole === 'Client' ? getValues : getValues2)(['TermAndConditions'])[0]) === true) {
            (typeRole === 'Client' ? setValue : setValue2)('TermAndConditions', null)
        }
    }, [typeRole]);
    const onSubmit = (data) => {
        const lg = navigator.language.includes('en') ? 0 : 1;
        const dataRequestProvider = {
            FirstName : data.FirstName ,
            LastName : data.LastName ,
            Email : email ,
            Role : typeRole === 'Respondent' ? 0 : 1,
            Company : data?.Company ?? "",
            TermAndConditions :  (data?.TermAndConditions === "true"),
            LoginType : location.state?._provider === "google" ? 2 : 3,
            Credential : location.state?._provider === "google" ? location.state?._token.idToken : location.state?._token.accessToken,
            languages: lg
        };
        dispatch(onChangeLanguage(lg))
        dispatch(onChangeLoading());
        loginService.PreRegisterExternal(dataRequestProvider).then(response => {
            if(response.status === 200){
                // URL OTP VALIDE
                // navigate('/SuccessConfirm' , { replace: true });
                localStorage.setItem('dataSocialMedia', JSON.stringify(location.state));
                myContext.setApplyApiKey(response.data.credential , true).then(response => {
                    myContext.notify6('success' , t('NOTIFICATIONS.TITLE_SUCCESS') , t('NOTIFICATIONS.DESCRIPTION_ACCOUNT_ACTIVE') );
                });
            } else if (response.status === 400 ) {
               myContext.notify6('alert' , 'Error' , t('NOTIFICATIONS.DESCRIPTION_USER_NO_REGISTER'));
            }
        }).catch(error => {
            myContext.notify6('alert' , 'Error' , ErrorParse(error) );
        }).finally(() => {
            dispatch(onChangeLoading());
        });
    };

    const getFormErrorMessage = (name, isClient) => <small className="p-error">{(isClient ? errors : errors2)[name]?.message}</small>;
    return (
        <div className="Register">
            <div className="content">
                <h2>{t('REGISTER.TITLE', {value: location.state?._profile.name})}</h2>
                <p>{t('REGISTER.DESCRIPTION')}</p>
                <div className="AccountType">
                    <label className={`AccountType-container ClientRegister ${typeRole === 'Client' ? "active" : ""}`}>{t('REGISTER.I_AM_CLIENT')}
                        <input onClick={() => setTypeRole('Client') } type="checkbox"></input>
                    </label>
                    <label className={`AccountType-container RespondantRegister ${typeRole === 'Respondent' ? "active" : ""}`}>{t('REGISTER.I_AM_RESPONDENT')}
                        <input onClick={() => setTypeRole('Respondent') } type="checkbox"></input>
                    </label>
                </div>
                <div className={`${typeRole === 'Client' ? 'ClientRegisterBox active' : 'RespondantRegisterBox active'}`}>
                    <p>{t(`REGISTER.DESCRIPTION_${typeRole === 'Client' ? 'CLIENT' : 'RESPONDANT'}_REGISTER_BOX`)}</p>
                    <form onSubmit={(typeRole === 'Client' ? handleSubmit : handleSubmit2)(onSubmit)}>
                        <input {...(typeRole === 'Client' ? register : register2)('FirstName', { required: true })}
                               defaultValue={location.state?._profile.firstName}
                               autoComplete='none' type="text" placeholder={t('RESPONDENT.SURVEY.FORM_SEND.FIRST_NAME')} className='p-inputtext p-component'/>
                        <input {...(typeRole === 'Client' ? register : register2)('LastName', { required: true })}
                               defaultValue={location.state?._profile.lastName}
                               autoComplete='none' type="text" placeholder={t('RESPONDENT.LIST.TABLE.LAST_NAME')} className='p-inputtext p-component'/>
                        {
                            typeRole === 'Client' ?
                                <input {...register('Company')}  type="text" autoComplete='none' placeholder={t('RESPONDENT.SURVEY.FORM_SEND.COMPANY_NAME')} className='p-inputtext p-component'/> :
                                <></>
                        }
                        <div className="terms">
                            <label htmlFor="TermAndConditions">
                                <input  type="checkbox" {...(typeRole === 'Client' ? register : register2)('TermAndConditions', {required: t('REGISTER.REQUIRED_CONDITIONS') } )}  name="TermAndConditions" id="TermAndConditions"  value={true} />
                                <span className="checkmark"></span>
                                {t('REGISTER.LABEL_ACCEPT')}
                                <a href={`/TerminosYCondiciones/${typeRole === 'Respondent' ? 'RESPONDENT' : 'CLIENT'}`} target="_blank">{t('REGISTER.LINK_TERMS_CONDITIONS')}</a>
                            </label>
                            <div className={"error-container"}>{getFormErrorMessage('TermAndConditions', typeRole === 'Client')}</div>
                        </div>
                        <input type="submit" value={t('SURVEY.CREATOR.BUTTON_CONTINUE')} className="p-button p-component"/>
                    </form>
                </div>
            </div>
        </div> 
    );
}
